/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ src: NonNullable<unknown> }} Jobs_Title_CommitInputs */

const cs_jobs_title_commit = /** @type {(inputs: Jobs_Title_CommitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.src} · import`)
};

const en_jobs_title_commit = /** @type {(inputs: Jobs_Title_CommitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.src} · import`)
};

/**
* | output |
* | --- |
* | "{src} · import" |
*
* @param {Jobs_Title_CommitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_title_commit = /** @type {((inputs: Jobs_Title_CommitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Title_CommitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_title_commit(inputs)
	return cs_jobs_title_commit(inputs)
});